// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3CzL6","actionsCol":"EnrolledClinics_actionsCol__1LZ3a"};